import { useTranslation } from "react-i18next";
import { Button, Input, message } from "antd";

import styles from "./HandbookPage.module.css";

type Props = {
  title: string;
  /** Код справочника — показывается рядом с названием и копируется по клику. */
  dictCode?: string;
  search: string;
  onSearchChange: (value: string) => void;
  /** В режиме привязки создавать записи нельзя — кнопки нет. */
  onCreate?: () => void;
};

export const HandbookPageHeader = ({
  title,
  dictCode,
  search,
  onSearchChange,
  onCreate,
}: Props) => {
  const { t } = useTranslation();

  const handleCopyDictCode = () => {
    if (!dictCode) return;
    navigator.clipboard
      .writeText(String(dictCode))
      .then(() => message.success("Скопировано"))
      .catch(() => message.error("Ошибка копирования"));
  };

  return (
    <div className={styles.header}>
      <div className={styles.title}>
        <span>{title}</span>

        <span
          className={styles.copyable}
          onClick={handleCopyDictCode}
          role="button"
          tabIndex={0}
        >
          {dictCode}
        </span>
      </div>

      <div className={styles.search}>
        <div className={styles.searchCard}>
          <Input
            placeholder={t("handbook.table.search")}
            value={search}
            size="large"
            allowClear
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>

        {onCreate && (
          <Button
            type="primary"
            size="large"
            onClick={onCreate}
            style={{ marginLeft: 10 }}
          >
            {t("handbook.table.create")}
          </Button>
        )}
      </div>
    </div>
  );
};
